import ScalarMenuLink_vue_vue_type_script_setup_true_lang_default from "./ScalarMenuLink.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarMenu/ScalarMenuLink.vue
var ScalarMenuLink_default = ScalarMenuLink_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarMenuLink_default as default };

//# sourceMappingURL=ScalarMenuLink.vue.js.map